import React from 'react'
import PropTypes from 'prop-types'
import Form from '../../../../../common/formComponents/Form'
import FormElement from '../../../../../common/formComponents/FormElement'
import withPolyglot from '../../../../../common/withPolyglot'

const RecommendationAdditionForm = ({translate, handleSubmit}) => {
  return <Form handleSubmit={handleSubmit}>
    <FormElement type={'number'} label={translate('doseNumber')} name={'doseNumber'} />
    <FormElement type={'date'} label={translate('earliest')} name={'earliest'} />
    <FormElement type={'date'} label={translate('recommended')} name={'recommended'} />
    <FormElement type={'date'} label={translate('latest')} name={'latest'} />
    <button className='uk-button uk-button-primary uk-align-right' type='submit'>{translate('submit')}</button>
  </Form>
}

RecommendationAdditionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired
}

export default withPolyglot(RecommendationAdditionForm, 'recommendationAddition')
